import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Sidebar } from "../Sidebar/Sidebar";
import MainContent from "../MainContent/MainContent";
import "./Dashboard.css";
import { Header } from "../Header";
import { useGetConceptMetaDataQuery } from "../../store/api/lumi/concepts";
import { useGetProjectByIdQuery } from "../../store/api/lumi/projects";
import { Spin, Button } from "antd";
import {
    LoadingOutlined,
    FilterOutlined,
    CloseOutlined,
} from "@ant-design/icons";
import {
    TabPanel,
    HeaderPanel,
    WidgetPanel,
    FiltersPanel,
    DashboardContent,
} from "../NewUI";
import { useGetDashboardListQuery } from "../../store/api/lumi/dashboard";

export const Dashboard = () => {
    const [showFilters, setShowFilters] = useState(false);
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const [isNewSidebarOpen, setNewIsSidebarOpen] = useState(false);
    const { id, dashboardName: nameFromParams  } = useParams();
    const { data: metaDataQu, isLoading } = useGetConceptMetaDataQuery(id);
     const { data: project } = useGetProjectByIdQuery(id);

   
    const [activeTab, setActiveTab] = useState(0);
 
   
     const navigate = useNavigate();
 
     const [searchParams] = useSearchParams();
     const isNewApp = searchParams.get("app") === "new";
     const defaultTabUrl = `/projects/${id}/dashboard${isNewApp ? "?app=new" : ""}`;
     const [tabs, setTabs] = useState([{
         name : 'Test Version',
         url : defaultTabUrl,
     }]);
     
     const [dashboardOptions, setDashboardOptions] = useState([]);
     const { data: dashboardList = [], isSuccess } =
         useGetDashboardListQuery(id);
 
     useEffect(() => {
         if(nameFromParams){
         if(tabs.findIndex(y => y.name === nameFromParams) < 0){
             const newTabs = [...tabs];
             newTabs.push({
             name : nameFromParams,
             url : `/projects/${id}/dashboard/${encodeURIComponent(nameFromParams)}${isNewApp ? "?app=new" : ""}`
         })
         setActiveTab(newTabs.length - 1);
         setTabs(newTabs);
     } else {
         setActiveTab(tabs.findIndex(y => y.name === nameFromParams));
     }
 }
     }, [nameFromParams])
 
     const handleChange = (_, option) => {
         const newTabs = [...tabs];
         const url = `/projects/${option.data.projectId}/dashboard/${encodeURIComponent(option.data.name)}${isNewApp ? "?app=new" : ""}`;
         newTabs.push({
             name : option.data.name,
             url : url
         })
         setTabs(newTabs);
         setActiveTab(newTabs.length);
         navigate(url);
     };
 
     const handleTabSelection = (index, url) => {
         if(url === `/projects/${id}/dashboard?app=new`){
             setDashboardOptions([]);
         }
         setActiveTab(index);
         navigate(url);
     }
 
     const addNewTab = (isDefault) => {
         const newTabs = [...tabs];
         if(isDefault){
         newTabs.push({
             name : `Tab ${newTabs.length}`,
             url : defaultTabUrl,
         })
     } 
     setTabs(newTabs);
     setActiveTab(newTabs.length - 1);
     navigate(defaultTabUrl);
     }
 
     useEffect(() => {
         if (isSuccess && dashboardList) {
             const options = dashboardList.map(
                 ({ dashboard_id: value, name: label, project_id, name }) => ({
                     label,
                     value,
                     data: {
                         projectId: project_id,
                         name,
                     },
                 })
             );
             setDashboardOptions(options);
         }
     }, [dashboardList, isSuccess]);
 
     const removeTab = (event,tabName) => {
         event.stopPropagation();
         const availableTabs = [...tabs];
         const filteredTabs = availableTabs.filter((item) => item.name !== tabName);
         setTabs(filteredTabs);
         navigate(defaultTabUrl);
         setActiveTab(0);
     }

     const updateName = (newName) => {
        const availableTabs = [...tabs];
        availableTabs[activeTab].name = newName;
     }

    if (isLoading) {
        return (
            <Spin
                className={"spinner-by-center"}
                data-testid="loadingSpinner"
                indicator={<LoadingOutlined style={{ fontSize: 60 }} spin />}
            />
        );
    }
    // New App
    if (isNewApp) {
        return (
            <div className="dashboard-UI">
                <div className="top-nav">
                    <div className="tab-section">
                        <TabPanel 
                        tabs={tabs}
                        activeTab={activeTab}
                        dashboardOptions={dashboardOptions}
                        removeTab={removeTab} 
                        addNewTab={addNewTab}
                        handleTabSelection={handleTabSelection}
                        handleChange={handleChange}
                        />
                    </div>
                    <div className="header-UI">
                        <HeaderPanel project={project} name={nameFromParams || tabs[activeTab].name} updateName={updateName}/>
                    </div>
                </div>
                <div className="main">
                    <div className="left">
                        <WidgetPanel
                            isSidebarOpen={isNewSidebarOpen}
                            setIsSidebarOpen={(status) =>
                                setNewIsSidebarOpen(status)
                            }
                            metaDataQu={metaDataQu}
                        />
                    </div>
                    <div className="center">
                        <div className="content">
                            <DashboardContent
                                width="325px"
                                id="new-content"
                                isSidebarOpen={isNewSidebarOpen}
                            />
                        </div>
                    </div>
                    {!showFilters && (
                        <div className="right-btn">
                            <Button
                                className="filter-btn"
                                icon={<FilterOutlined />}
                                onClick={() => setShowFilters(true)}
                            />
                        </div>
                    )}
                    {showFilters && (
                        <div className="right">
                            <Button
                                className="close-btn"
                                icon={<CloseOutlined />}
                                onClick={() => setShowFilters(false)}
                            />
                            <FiltersPanel />
                        </div>
                    )}
                </div>
            </div>
        );
    }

    // Old App
    return (
        <div
            className={`dashboard ${isSidebarOpen ? "dashboard-full-width" : ""}`}
        >
            <Sidebar
                isSidebarOpen={isSidebarOpen}
                setIsSidebarOpen={setIsSidebarOpen}
                metaDataQu={metaDataQu}
            />
            <div className="main-content">
                <Header />
                <MainContent id="main-content" isSidebarOpen={isSidebarOpen} />
            </div>
        </div>
    );
};
